import config from "./config";
var axios = config();

export default {
  getById(id) {
    return axios.get("/api/AdministrativeRequests/" + id);
  },

  getAllRequests() {
    return axios.get("/api/AdministrativeRequests");
  },

  getStatusDefinitions() {
    return axios.get("/api/AdministrativeRequests/statuses");
  },

  getStatusByDefinition(id) {
    return axios.get("/api/AdministrativeRequests/statuses" + id);
  },

  postStatus(adminRequest) {
    return axios.post("/api/AdministrativeRequests/status", adminRequest);
  },

  updateRequest(adminRequest) {
    return axios.put("/api/AdministrativeRequests", adminRequest);
  },

  statusEmail(id) {
    return axios.post("/api/AdministrativeRequests/statusEmail/" + id);
  }
};
